!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.viewabilityFramework = t() : e.viewabilityFramework = t();
}(window, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 4);
  }([function (e) {
    e.exports = JSON.parse('{"image":{"intersectionRatio":0.5,"timeout":1000},"large-image":{"intersectionRatio":0.3,"timeout":1000},"video":{"intersectionRatio":0.5,"timeout":2000}}');
  }, function (e, t, n) {
    (function (t) {
      e.exports = function (e) {
        var t = {};
        function n(r) {
          if (t[r]) return t[r].exports;
          var i = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function (e, t, r) {
          n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
          });
        }, n.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, n.t = function (e, t) {
          if (1 & t && (e = n(e)), 8 & t) return e;
          if (4 & t && "object" == typeof e && e && e.__esModule) return e;
          var r = Object.create(null);
          if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
            return e[t];
          }.bind(null, i));
          return r;
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
      }([function (e, t, n) {
        "use strict";

        n.r(t), n.d(t, "createEventQueue", function () {
          return o;
        }), n.d(t, "QueuedEventHandler", function () {
          return i;
        }), n.d(t, "createPrioritizedEventQueue", function () {
          return u;
        }), n.d(t, "PrioritizedQueuedEventHandler", function () {
          return s;
        });
        class r {
          constructor() {
            this.isLogger = !0, this._logs = {
              error: [],
              warn: [],
              info: []
            }, this.info = this.info.bind(this), this.error = this.error.bind(this), this.warn = this.warn.bind(this);
          }
          info(e) {
            this._logs.info.push(e);
          }
          error(e) {
            this._logs.error.push(e);
          }
          warn(e) {
            this._logs.warn.push(e);
          }
          get logs() {
            return this._logs;
          }
        }
        class i {
          constructor(e, t = []) {
            if (!Array.isArray(t)) throw new Error("Meso event queue requires an array.");
            this._callback = e, this._executedEvents = [], this._unExecutedEvents = t, this.isEventQueue = !0, this.logger = new r();
          }
          push(...e) {
            this._executedEvents.push(...e), this._callback(...e);
          }
          executeQueue(e = this._unExecutedEvents.length) {
            for (; this._unExecutedEvents.length > 0 && e > 0;) this.push(this._unExecutedEvents.shift()), e -= 1;
          }
          history() {
            console.table(this._executedEvents);
          }
          get executedEvents() {
            return this._executedEvents;
          }
          get unExecutedEvents() {
            return this._unExecutedEvents;
          }
        }
        const o = (e, t = [], n = {}, r) => {
          const o = new i(e, t);
          return void 0 !== r && (window.meso[r] = o), o.executeQueue(n.limit), n.observable && (o.observe = (e, t, r) => n.observable.observe(e, t, r)), o;
        };
        class s extends i {
          constructor(e, t = [], n = []) {
            super(e, t), this._priorityOrder = n, this._invalidEvents = this._unExecutedEvents.filter(e => !this._isValidEvent(e)), this._unExecutedEvents = this._unExecutedEvents.filter(e => this._isValidEvent(e)), this._sortEvents();
          }
          executeQueue(e = this._unExecutedEvents.length) {
            const t = [];
            this._priorityOrder.forEach(n => {
              let r = e;
              const i = this._unExecutedEvents.filter(e => e.type === n);
              for (; i.length > 0 && r > 0;) this.push(i.pop()), r -= 1;
              t.concat(i);
            }), this._unExecutedEvents = t;
          }
          _isValidEvent(e) {
            return "object" == typeof e && null !== e && void 0 !== e.type && -1 !== this._priorityOrder.indexOf(e.type);
          }
          _sortEvents() {
            this._unExecutedEvents.sort((e, t) => {
              const n = this._priorityOrder.indexOf(e.type),
                r = this._priorityOrder.indexOf(t.type);
              return -1 === n || -1 === r ? 0 : n - r;
            });
          }
          get invalidEvents() {
            return this._invalidEvents;
          }
        }
        const u = (e, t = [], n = [], r = {}) => {
          const i = new s(e, t, n);
          return i.executeQueue(r.limit), r.observable && (i.observe = (e, t, n) => r.observable.observe(e, t, n)), i;
        };
      }]);
    }).call(this, n(3));
  }, function (e, t, n) {
    window, e.exports = function (e) {
      var t = {};
      function n(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }
      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 2);
    }([function (e, t, n) {
      (function (t) {
        e.exports = function (e) {
          var t = {};
          function n(r) {
            if (t[r]) return t[r].exports;
            var i = t[r] = {
              i: r,
              l: !1,
              exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
          }
          return n.m = e, n.c = t, n.d = function (e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
              enumerable: !0,
              get: r
            });
          }, n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(e, "__esModule", {
              value: !0
            });
          }, n.t = function (e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
              enumerable: !0,
              value: e
            }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
              return e[t];
            }.bind(null, i));
            return r;
          }, n.n = function (e) {
            var t = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return n.d(t, "a", t), t;
          }, n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, n.p = "", n(n.s = 0);
        }([function (e, t, n) {
          "use strict";

          n.r(t), n.d(t, "createEventQueue", function () {
            return o;
          }), n.d(t, "QueuedEventHandler", function () {
            return i;
          }), n.d(t, "createPrioritizedEventQueue", function () {
            return u;
          }), n.d(t, "PrioritizedQueuedEventHandler", function () {
            return s;
          });
          class r {
            constructor() {
              this.isLogger = !0, this._logs = {
                error: [],
                warn: [],
                info: []
              }, this.info = this.info.bind(this), this.error = this.error.bind(this), this.warn = this.warn.bind(this);
            }
            info(e) {
              this._logs.info.push(e);
            }
            error(e) {
              this._logs.error.push(e);
            }
            warn(e) {
              this._logs.warn.push(e);
            }
            get logs() {
              return this._logs;
            }
          }
          class i {
            constructor(e, t = []) {
              if (!Array.isArray(t)) throw new Error("Meso event queue requires an array.");
              this._callback = e, this._executedEvents = [], this._unExecutedEvents = t, this.isEventQueue = !0, this.logger = new r();
            }
            push(...e) {
              this._executedEvents.push(...e), this._callback(...e);
            }
            executeQueue(e = this._unExecutedEvents.length) {
              for (; this._unExecutedEvents.length > 0 && e > 0;) this.push(this._unExecutedEvents.shift()), e -= 1;
            }
            history() {
              console.table(this._executedEvents);
            }
            get executedEvents() {
              return this._executedEvents;
            }
            get unExecutedEvents() {
              return this._unExecutedEvents;
            }
          }
          const o = (e, t = [], n = {}, r) => {
            const o = new i(e, t);
            return void 0 !== r && (window.meso[r] = o), o.executeQueue(n.limit), n.observable && (o.observe = (e, t, r) => n.observable.observe(e, t, r)), o;
          };
          class s extends i {
            constructor(e, t = [], n = []) {
              super(e, t), this._priorityOrder = n, this._invalidEvents = this._unExecutedEvents.filter(e => !this._isValidEvent(e)), this._unExecutedEvents = this._unExecutedEvents.filter(e => this._isValidEvent(e)), this._sortEvents();
            }
            executeQueue(e = this._unExecutedEvents.length) {
              const t = [];
              this._priorityOrder.forEach(n => {
                let r = e;
                const i = this._unExecutedEvents.filter(e => e.type === n);
                for (; i.length > 0 && r > 0;) this.push(i.pop()), r -= 1;
                t.concat(i);
              }), this._unExecutedEvents = t;
            }
            _isValidEvent(e) {
              return "object" == typeof e && null !== e && void 0 !== e.type && -1 !== this._priorityOrder.indexOf(e.type);
            }
            _sortEvents() {
              this._unExecutedEvents.sort((e, t) => {
                const n = this._priorityOrder.indexOf(e.type),
                  r = this._priorityOrder.indexOf(t.type);
                return -1 === n || -1 === r ? 0 : n - r;
              });
            }
            get invalidEvents() {
              return this._invalidEvents;
            }
          }
          const u = (e, t = [], n = [], r = {}) => {
            const i = new s(e, t, n);
            return i.executeQueue(r.limit), r.observable && (i.observe = (e, t, n) => r.observable.observe(e, t, n)), i;
          };
        }]);
      }).call(this, n(1));
    }, function (e, t) {
      var n;
      n = function () {
        return this;
      }();
      try {
        n = n || new Function("return this")();
      } catch (e) {
        "object" == typeof window && (n = window);
      }
      e.exports = n;
    }, function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "initializeBeaconFramework", function () {
        return u;
      });
      var r = n(0);
      const i = Object.freeze({
          URL: "URL",
          URLMAX: "URLMAX",
          UNKNOWN: "UNKNOWN"
        }),
        o = (e, t) => {
          switch (((e, t) => void 0 === t ? 4096 > e.length ? i.URL : i.URLMAX : i.UNKNOWN)(e, t)) {
            case i.UNKNOWN:
              throw new Error("Unsupported data type being sent to Beacon Framework.");
            case i.URLMAX:
              throw new Error("Query string data is bigger than max size allowed for type: URL.");
            default:
              if (navigator.sendBeacon(e, t)) return !0;
          }
          return ((e, t) => {
            ((e, t = {}) => {
              const n = t && t.timeout || 5e3;
              return Promise.race([fetch(e, t), new Promise((e, t) => setTimeout(() => t(new Error("Timeout")), n))]);
            })(e, {
              method: "POST",
              headers: {
                Accept: "application/x-www-form-urlencoded",
                "Content-Type": "application/x-www-form-urlencoded"
              },
              body: JSON.stringify(t)
            }).then(e => !(e && e.errors && e.errors.length > 0));
          })(e, t);
        },
        s = e => {
          if ("beacon" === e.type) {
            const {
              url: t,
              data: n
            } = e;
            o(t, n);
          }
        },
        u = () => {
          window.meso = window.meso || {}, window.meso.beacons = window.meso.beacons || [], window.meso.beacons.isEventQueue || (window.meso.beacons = Object(r.createEventQueue)(s, window.meso.beacons, {}, "beacons"));
        };
    }]);
  }, function (e, t) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "initializeViewability", function () {
      return a;
    });
    var r = n(1),
      i = n(2),
      o = n(0);
    const s = new Map();
    class u {
      constructor(e) {
        this._element = e.element, this._beacons = e.beacons || e.beacon, this._isViewable = !1, this._intersectionRatio = o[e.config].intersectionRatio, this._timeout = o[e.config].timeout, this._viewabilityTimeoutcb = () => setTimeout(() => {
          "true" !== this._element.getAttribute("data-meso-viewed") && (this._element.setAttribute("data-meso-viewed", "true"), this._impressionOccurred(e.beacon));
        }, this._timeout), this.registerSessionObserver();
      }
      get isViewable() {
        return this._isViewable;
      }
      deregisterSessionObserver() {
        this._sessionObserver.disconnect();
      }
      registerSessionObserver() {
        this._sessionObserver = new IntersectionObserver(e => {
          for (const t of e) {
            const {
              width: e,
              height: n
            } = t.boundingClientRect;
            !t.target.hidden && e > 0 && n > 0 && t.intersectionRatio >= this._intersectionRatio ? (this.timeoutId = this._viewabilityTimeoutcb(), this._element.setAttribute("data-meso-inview", ""), this._isViewable = !0) : (clearTimeout(this.timeoutId), this._element.removeAttribute("data-meso-inview"), this._isViewable = !1);
          }
        }, {
          threshold: [this._intersectionRatio]
        }), this._sessionObserver.observe(this._element);
      }
      _isValidURL(e) {
        try {
          new URL(e);
        } catch (e) {
          return !1;
        }
        return !0;
      }
      _impressionOccurred() {
        (Array.isArray(this._beacons) ? this._beacons : [this._beacons]).forEach(e => this._sendBeacon(e));
      }
      _sendBeacon(e) {
        this._isValidURL(e) ? window.meso.beacons.push({
          type: "beacon",
          url: e
        }) : window.meso.viewability.logger.info({
          methodName: "_sendBeacon",
          info: "beacon not found or invalid; beacon url: " + e
        });
      }
    }
    const c = e => {
        if (null !== e && "object" == typeof e) switch (e.type) {
          case "clear":
            (() => {
              for (const e of s.values()) e.forEach(e => {
                e.deregisterSessionObserver();
              });
              s.clear();
            })();
            break;
          case "deregister":
            (({
              element: e
            }) => {
              e ? s.has(e) ? (s.get(e).forEach(e => {
                e.deregisterSessionObserver();
              }), s.delete(e)) : window.meso.viewability.logger.info({
                methodName: "unsetSlotElement",
                description: "Could not find element to deregister"
              }) : window.meso.viewability.logger.warn({
                description: "Error reading element from payload",
                methodName: "unsetSlotElement"
              });
            })(e);
            break;
          case "register":
            (e => {
              const {
                element: t
              } = e;
              t && t.nodeType && 1 === t.nodeType ? s.set(t, [...(s.get(t) || []), new u(e)]) : window.meso.viewability.logger.warn({
                description: "Error reading element from payload",
                methodName: "setSlotElement"
              });
            })(e);
        }
      },
      a = () => {
        if (window.meso = window.meso || {}, window.meso.viewability = window.meso.viewability || [], window.meso.viewability.isEventQueue) return;
        Object(i.initializeBeaconFramework)();
        window.meso.viewability = Object(r.createPrioritizedEventQueue)(c, window.meso.viewability, ["clear", "deregister", "register"], {});
      };
  }]);
});